/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import CommunityChallengeProgress from '@/components/CommunityChallengeProgress/index.vue';
import CommunityChallengeContribution from '@/components/CommunityChallengeContribution/index.vue';
import CommunityChallengeStanding from '@/components/CommunityChallengeStanding/index.vue';
import {
    ActiveCommunityChallengeStateInterface,
    CommunityChallengeInterface,
} from '@/store/modules/community-challenge/types';
import {Action, Getter} from 'vuex-class';
import Utils from '@/services/utils';

/**
 * Community Challenges In Game View.
 * @author Mark Thompson <mthompson@frontier.co.uk>
 */
@Component({
    name: 'v-active-community-challenge',
    components: {
        'c-community-challenge-progress' : CommunityChallengeProgress,
        'c-community-challenge-contribution' : CommunityChallengeContribution,
        'c-community-challenge-standing' : CommunityChallengeStanding,
    },
})
export default class ActiveCommunityChallenge extends Vue {
    @Action('getCurrentChallenge', {namespace: 'communityChallengeModule'})
    public getCurrentChallenge!: () => ActiveCommunityChallengeStateInterface;

    @Getter('challenge', {namespace: 'communityChallengeModule'})
    public challenge!: CommunityChallengeInterface;

    public loading: boolean = false;

    /**
     * Runs when view is created
     */
    public async created(): Promise<void> {
        try {
            this.loading = true;
            await this.getCurrentChallenge();
            await Utils.timeout(500);
        } catch (e) {
            // do nothing
        }
        this.loading = false;
    }
}
